<div class="screenshot-toolbar"
  data-screenshot-ignore
  [ngStyle]="positionStyles">

  <button type="button"
    class="screenshot-toolbar-btn"
    (click)="onCopy()"
    [disabled]="isCopying"
    data-screenshot-ignore>
    <mat-icon>content_copy</mat-icon>
    Copy
  </button>

  <button type="button"
    class="screenshot-toolbar-btn screenshot-toolbar-btn--primary"
    (click)="onSave()"
    data-screenshot-ignore>
    <mat-icon>save</mat-icon>
    Save to Document
  </button>
</div>
